import React, { useEffect } from "react";
import * as Yup from "yup";
import { Formik, FastField } from "formik";
import { CheckboxField } from "../../formik";
import { Output } from "../../Text";
import { Icon } from "../Polyfill.jsx";
import {
  Button,
  ButtonContainer,
  InstructionStepper,
  ContentSection,
  Form,
  PageWrap,
  Paragraph,
} from "@vwfs-bronson/bronson-react";
import { Optional } from "../../common/Optional";
import { Analytics } from "../../services/analytics";
import { setActualPage } from "../../pages/page.utils";
import { isVtiBOP, isHeycarBOP } from "../../common/JourneyType";

const AcceptanceEsign = ({
  inspectionReportLink,
  originSystem,
  onSubmit,
  identificationStarted,
}) => {
  const pageName = "Signature";

  const defaultTrackingData = {
    [Analytics.keys.pageName()]: pageName,
    [Analytics.keys.viewChange()]: pageName,
  };

  const trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.eventType(0)]: "pageView",
        [Analytics.keys.eventAction(0)]: "Success",
        [Analytics.keys.eventType(1)]: "Product journey supplement",
        [Analytics.keys.eventAction(1)]: "Start",
      };
      Analytics.setTrackingData({ ...defaultTrackingData, ...pageData });
      Analytics.trackPage();
    }, 1000);
  };
  useEffect(() => {
    setActualPage(pageName);
    trackPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const acceptWarrantySchema = Yup.object().shape({
    acceptWarrantyCheck: Yup.boolean()
      .required("")
      .oneOf([true], Output.resolve("generic.errors.M001_mandatoryFields")),
  });

  const onLocalSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit();
    }
  };

  const getWarrantyDocUrl = () => "\\assets\\docs\\Garantierversicherungsunterlagen_PerfectCar_PRO.pdf";

  return (
    <>
      <ContentSection pale>
        <PageWrap size="small">
          <div className="u-text-center">
            <Icon icon={"semantic-checkmark"} size={"xxlarge"} />
            <h2>{Output.resolve("pages.esign.title")}</h2>
          </div>
        </PageWrap>
      </ContentSection>
      <ContentSection>
        <PageWrap size="small">
          <ContentSection.ComponentWrapper>
            {Output.resolveAsMarkdown(
              "pages.esign.signingPossible.instructionStepper.text"
            )}
          </ContentSection.ComponentWrapper>
          <InstructionStepper>
            {Optional.of(
              Output.resolve(
                "pages.esign.signingPossible.instructionStepper.steps"
              )
            )
              .orElse([])
              .map((step, i) => (
                <InstructionStepper.Step
                  key={i}
                  icon={step.icon}
                  state={"is-active"}
                  title={step.label}
                  displayIcons
                >
                  {step.description}
                </InstructionStepper.Step>
              ))}
          </InstructionStepper>
        </PageWrap>
      </ContentSection>
      <ContentSection pale>
        <PageWrap size="small">
          {Output.resolveAsMarkdown(
            "pages.esign.signingPossible.instructionStepper.text2"
          )}
          <hr />
          <ContentSection className="u-pt-none">
            {!identificationStarted && (
              <>
                <Paragraph>
                  {Output.resolve("pages.esign.signingPossible.legal.1")}
                </Paragraph>
                <Paragraph>
                  {Output.resolve("pages.esign.signingPossible.legal.2")}
                </Paragraph>
              </>
            )}

            <Paragraph>
              <Formik
                initialValues={{
                  acceptWarrantyCheck:
                    (isVtiBOP(originSystem) || isHeycarBOP(originSystem)) &&
                    !identificationStarted
                      ? false
                      : true,
                }}
                validationSchema={acceptWarrantySchema}
                onSubmit={(e) => {
                  onLocalSubmit(e);
                }}
                validateOnMount={true}
                render={({ isValid }) => {
                  return (
                    <Form floatingLabel onSubmit={(e) => onLocalSubmit(e)}>
                      {(isVtiBOP(originSystem) || isHeycarBOP(originSystem)) &&
                        !identificationStarted && (
                          <>
                            <Paragraph>
                              <FastField
                                name="acceptWarrantyCheck"
                                label={
                                  <>
                                    <Paragraph className="u-mb-none">
                                      {Output.resolve(
                                        "pages.esign.signingPossible.acceptWarrantyCheckbox.text_pre"
                                      )}
                                      <a
                                        href={getWarrantyDocUrl()}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {Output.resolve(
                                          "pages.esign.signingPossible.acceptWarrantyCheckbox.linkText"
                                        )}
                                      </a>
                                      .
                                    </Paragraph>
                                    <Paragraph>
                                      {Output.resolve(
                                        "pages.esign.signingPossible.acceptWarrantyCheckbox.text_after"
                                      )}
                                    </Paragraph>
                                  </>
                                }
                                component={CheckboxField}
                              />
                            </Paragraph>
                          </>
                        )}
                      <ButtonContainer>
                        <Button type={"submit"} disabled={!isValid}>
                          {Output.resolve(
                            "pages.esign.signingPossible.buttonNext"
                          )}
                        </Button>
                      </ButtonContainer>
                    </Form>
                  );
                }}
              />
            </Paragraph>
          </ContentSection>
        </PageWrap>
      </ContentSection>
    </>
  );
};

export default AcceptanceEsign;
